﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

import type { PostSelfServiceRegistrationResponseSuccess } from "~jrad/Services/API/Account/PostSelfServiceRegistration";
import type { PostSelfServiceRegistrationResponseFailure } from "~jrad/Services/API/Account/PostSelfServiceRegistration";
import type { DataGatheringStatus } from "~jrad/Services/API/Account/PostSelfServiceRegistrationAppStatus";

//-------------------------------------------------------------------------------------
// Enums
//-------------------------------------------------------------------------------------

export enum SelfServiceClaim {
    FirstName = "VisiFinance.Consilio.SoPNL.Security.FirstName",
    LastName = "VisiFinance.Consilio.SoPNL.Security.LastName",
    BirthDate = "VisiFinance.Consilio.SoPNL.Security.BirthDate",
}

//-------------------------------------------------------------------------------------
// Types
//-------------------------------------------------------------------------------------

export enum SelfServiceRegistrationPage {
    Account,
    SelectTenant,
    TermsOfService,
    EnterClaims,
    AppRegistration,
}

export interface SelfServiceViewState {
    errorMessage?: string;
    page: SelfServiceRegistrationPage;
    nextPageAfterLoading: SelfServiceRegistrationPage;

    waitForTextCodesToLoad?: boolean;

    requestData: SelfServiceRequestData;

    responseHasError: boolean;
    responseData: Omit<PostSelfServiceRegistrationResponseSuccess, "HasError">;
    responseError: SelfServiceErrorState;

    verificationStatus?: DataGatheringStatus;
}

export type SelfServiceErrorState = {
    email?: string;
    password?: string;
    firstName?: string;
    lastName?: string;
    birthDate?: string;
};

export type SelfServiceRequestData = {
    email?: string;
    password?: string;
    passwordConfirm?: string;

    tenantUid?: string;

    claims: SelfServiceRequestDataClaims;

    hasAcceptedToS: boolean;
};

export type SelfServiceRequestDataClaims = {
    firstName?: string;
    lastName?: string;
    birthDate?: string;
};
